import React, { useState, useEffect, useMemo } from "react";
import AddressBook from "../account/account-address";
const CheckoutAddress = ({
  addresses,
  customerInfo,
  setSelectedAddressType,
  addressType,
  updateSC,
  updateSelectedCountry,
  title
}) => {
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const sortedAddresses = useMemo(() => {
    return [...addresses].sort((a, b) => {
      if (a.defaultAddress && !b.defaultAddress) return -1;
      if (!a.defaultAddress && b.defaultAddress) return 1;
      return a.addressName.localeCompare(b.addressName);
    });
  }, [addresses]);

  useEffect(() => {
    if (sortedAddresses?.length) {
      const addressToSelect =
        sortedAddresses.find((a) => a.defaultAddress) || sortedAddresses[0];
      setSelectedAddress(addressToSelect);
    }
  }, [addresses]);

  useEffect(() => {
    setSelectedAddressType(selectedAddress);
    updateSelectedCountry(selectedAddress?.country, addressType);
  }, [selectedAddress]);


  const handleOpenModal = (e) => {
    e.preventDefault()
    e.stopPropagation();
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="card">
        <h2 className="section-title">{title}</h2>

        {isModalOpen && (
          <div className="modal-overlay" onClick={handleCloseModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h2>
                  {addresses.length === 0
                    ? "Add Shipping Address"
                    : "Select Shipping Address"}
                </h2>
                <button className="close-btn" onClick={handleCloseModal}>
                  &times;
                </button>
              </div>

              <AddressBook
                addresses={addresses}
                isCheckout={true}
                selectedAddress={selectedAddress}
                onSelect={setSelectedAddress}
                addressType={addressType}
                updateSC={updateSC}
                handleCloseModal={handleCloseModal}
                customerInfo={customerInfo}
                // isAddingNew={isAddingNew}
              />
            </div>
          </div>
        )}

        {addresses.length > 0 ? (
          <div className="saved-address-card">
            {selectedAddress?.isDefault && (
              <span className="address-badge">Default</span>
            )}
            <h4>{selectedAddress?.addressName || "Select Address"}</h4>
            <div className="address-details">
              <p style={{ margin: 0 }}>
                {selectedAddress?.countryCode} {selectedAddress?.mobileNo} | {selectedAddress?.email}
              </p>
              <p style={{ margin: "10px 0 0 0", fontWeight: 500 }}>
                {selectedAddress?.address} <br />
                {selectedAddress?.city} {selectedAddress?.state}{" "}
                 {selectedAddress?.country} - {selectedAddress?.zip}
              </p>
            </div>
            <div className="address-actions">
              <button
                className="text-btn"
                onClick={(e) => { handleOpenModal(e, selectedAddress); }}
              >
                Edit Address / Add New
              </button>
            </div>
          </div>
        ) : (
          <div className="empty-address-card">
            <div className="empty-icon">+</div>
            <div style={{ textAlign: "center" }}>
              <h4 style={{ margin: "0 0 4px 0" }}>No saved addresses found</h4>
              <p style={{ margin: 0, fontSize: "0.85rem", color: "#64748b" }}>
                Please add a shipping address to proceed with your order.
              </p>
            </div>
            <button
              className="add-first-btn"
              onClick={() => setIsModalOpen(true)}
            >
              ADD NEW ADDRESS
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default CheckoutAddress;
